import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'order-submission-error',
		pluralName: 'order-submission-errors',
		transport: 'connect',
		basePath: 'order-submission-errors',
		options: {
			namespaced: true,
			actions: {
				find: {
					dataProp: 'data', // -> `data` in the response payload
					countProp: 'total' // -> `count` in the response payload
				}
			}
		}
	});
}